<div class="page center tiny" *ngIf="platformBrowser">
  <div class="page-inner">
    <div class="gallery-image" #el *ngIf="gallery.teaser.uuid">
      <img [src]="gallery | galleryTeaserUrl : el.clientWidth" alt="" />
    </div>
    <h1 class="gallery-title">Enter your details</h1>
    <h3 class="gallery-info" *ngIf="tenant.name">
      No signup required. Just add some info to let <b>{{ tenant.name }}</b> know who you are.
    </h3>
    <h3 class="gallery-info" *ngIf="!tenant.name">
      No signup required. Just add some info to let the owner of this gallery know who you are.
    </h3>
    <form
      [formGroup]="form"
      #ngForm="ngForm"
      [class.submitted]="ngForm.submitted"
      class="form-container"
      (ngSubmit)="submit()"
    >
      <app-input-field [control]="form.controls.name" [big]="true">
        <!-- <app-svg src="/assets/icons/user.svg" *appInputPre></app-svg> -->
        <input type="text" formControlName="name" appAutofocus />
        <label>Name</label>
      </app-input-field>
      <app-input-field [control]="form.controls.email" [big]="true">
        <!-- <app-svg src="/assets/icons/email.svg" *appInputPre></app-svg> -->
        <input type="email" formControlName="email" />
        <label>Email</label>
      </app-input-field>

      <button
        appButton
        name="view-gallery"
        location="gallery-identify-page"
        color="primary"
        weight="bold"
        height="4"
        size="3"
        shape="round"
        spacing="full"
        class="cta"
      >
        <span [class.hidden-text]="loading">Enter Gallery</span>
        <app-loading-indicator *ngIf="loading" color="white" size="small" class="button-loading-indicator">
        </app-loading-indicator>
      </button>
      <p class="legal small">
        You agree to our <a href="https://picflow.com/terms" target="_blank">Terms of Service</a> and you’re protected
        by reCAPTCHA. The Google
        <a href="https://policies.google.com/privacy?hl=en-GB" target="_blank" rel="nofollow noreferrer noopener"
          >Privacy Policy</a
        >
        applies.
      </p>
    </form>
  </div>
</div>

<div class="page center tiny loading" *ngIf="!platformBrowser">
  <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
</div>
